import { ImageCarousel } from '@/components/ui/images/image-carousel/ImageCarousel';

export const SmallCarouselImageItem = ({ data }) => {
  const imagePrefix = '';
  return (
    <ImageCarousel
      src={imagePrefix + data?.fields?.small_img_highlight}
      alt={data?.fields?.alt_img}
      sizes={{
        width: data?.fields?.sizes?.width ?? 461,
        height: data?.fields?.sizes?.height ?? 461,
      }}
    />
  );
};
